import { createContext, useContext } from "react"

const WrapperModalsContext = createContext()

export const useWrapperModals = () => useContext(WrapperModalsContext)

export default WrapperModalsContext
